import { Route, routeParams } from '@/routes';
import { WorkspaceDocumentsEmbeddedTab } from '@/components/WorkspaceDocuments/WorkspaceDocuments.types';
import { DigitalizationProjectDetailsTab } from '@/views/DigitalizationProjectDetails/DigitalizationProjectDetails.types';
import { ProjectDetailsTab } from '@/views/ProjectDetails/ProjectDetails.types';
import { WorkspaceDetailsTab } from '@/views/WorkspaceDetails/WorkspaceDetails.types';
import { ProjectType } from 'types';
import { useRouter } from 'vue-router';

export function useNavigator() {
  const router = useRouter();

  function goToProjectDetailsTab(
    projectType: ProjectType,
    projectId: string,
    supplierProjectTab: ProjectDetailsTab,
    digitalizationProjectTab: DigitalizationProjectDetailsTab,
  ) {
    if (projectType === ProjectType.SUPPLIER_PROJECT) {
      router.push({
        name: Route.PROJECT_DETAILS,
        params: {
          [routeParams[Route.PROJECT_DETAILS].projectId]: projectId,
          [routeParams[Route.PROJECT_DETAILS].tab]: supplierProjectTab,
        },
      });
    } else if (projectType === ProjectType.DIGITALIZATION_PROJECT) {
      router.push({
        name: Route.DIGITALIZATION_PROJECT_DETAILS,
        params: {
          [routeParams[Route.DIGITALIZATION_PROJECT_DETAILS].projectId]:
            projectId,
          [routeParams[Route.DIGITALIZATION_PROJECT_DETAILS].tab]:
            digitalizationProjectTab,
        },
      });
    } else throw new Error('Unknown project type');
  }

  function goToWorkspaceDetailsTab(
    workspaceId: string,
    tab: WorkspaceDetailsTab,
  ): void {
    router.push({
      name: Route.WORKSPACE_DETAILS,
      params: {
        [routeParams[Route.WORKSPACE_DETAILS].workspaceId]: workspaceId,
        [routeParams[Route.WORKSPACE_DETAILS].tab]: tab,
      },
    });
  }

  function goToWorkspaceDocumentDetailView(
    workspaceId: string,
    documentId: string,
    documentsTab: WorkspaceDocumentsEmbeddedTab = WorkspaceDocumentsEmbeddedTab.EDITABLE,
  ): void {
    router.push({
      name: Route.WORKSPACE_DOCUMENT_DETAIL_VIEW,
      params: {
        [routeParams[Route.WORKSPACE_DOCUMENT_DETAIL_VIEW].workspaceId]:
          workspaceId,
        [routeParams[Route.WORKSPACE_DOCUMENT_DETAIL_VIEW].documentId]:
          documentId,
      },
      query: {
        [routeParams[Route.WORKSPACE_DOCUMENT_DETAIL_VIEW].query.documentsTab]:
          documentsTab,
      },
    });
  }

  return {
    goToProjectDetailsTab,
    goToWorkspaceDetailsTab,
    goToWorkspaceDocumentDetailView,
  };
}
